import React from 'react';

// The pieces a help guide is built from, shared by every page's guide so they
// all read the same way. A guide is one continuous scroll rather than paged
// steps: it reads in the order the page is used, and Ctrl+F finds anything.

// An on-screen control, named the way it is labelled in the app — so the reader
// can match what they are told to what they are looking at.
export const UI = ({ icon, children }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      padding: '1px 7px',
      margin: '0 1px',
      borderRadius: 5,
      border: '1px solid var(--rs-border-primary, #d9d9d9)',
      background: 'var(--rs-bg-card, #fff)',
      fontWeight: 600,
      fontSize: '0.92em',
      whiteSpace: 'nowrap',
    }}
  >
    {icon ? <i className={`bi ${icon}`} aria-hidden="true" /> : null}
    {children}
  </span>
);

export const Section = ({ title, children }) => (
  <div style={{ marginBottom: 18 }}>
    <div style={{ fontWeight: 600, marginBottom: 6 }}>{title}</div>
    <div style={{ lineHeight: 1.6 }}>{children}</div>
  </div>
);

export const Note = ({ tone = 'info', title, children }) => {
  const palette = tone === 'warn'
    ? { border: '#f5c6c2', background: '#fef3f2', color: '#b42318' }
    : { border: '#a9cfd2', background: '#e2f0f1', color: '#0d5c63' };

  return (
    <div
      style={{
        marginTop: 12,
        padding: '10px 12px',
        borderRadius: 6,
        border: `1px solid ${palette.border}`,
        background: palette.background,
        color: palette.color,
        lineHeight: 1.55,
      }}
    >
      {title ? <div style={{ fontWeight: 700, marginBottom: 4 }}>{title}</div> : null}
      {children}
    </div>
  );
};

export const List = ({ children }) => (
  <ul style={{ margin: '4px 0 0', paddingLeft: 20, lineHeight: 1.7 }}>{children}</ul>
);

// One stage of the guide. The whole thing is a single scroll, so these titles
// are what the eye catches on the way past — deliberately larger and ruled off,
// a step above the bold Section headings nested under them.
export const Chapter = ({ title, icon, first = false, children }) => (
  <section style={{ marginTop: first ? 0 : 34 }}>
    <h4
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        margin: '0 0 14px',
        paddingBottom: 8,
        borderBottom: '1px solid var(--rs-border-primary, #e5e5e5)',
        fontSize: 20,
        fontWeight: 700,
      }}
    >
      <i className={`bi ${icon}`} aria-hidden="true" />
      {title}
    </h4>
    {children}
  </section>
);
